const safeCall = (fn, user, requiredKey) => {
  if (!user || (requiredKey && !user[requiredKey])) return;
  if (typeof fn === "function") {
    fn(user);
  }
};

export const createUserActionHandlers = ({
  onDelete,
  onResetPassword,
  onEditUser,
  onViewUser,
}) => ({
  handleView: (user) => safeCall(onViewUser, user, "_id"),
  handleDelete: (user) => safeCall(onDelete, user, "_id"),
  handleEdit: (user) => safeCall(onEditUser, user, "_id"),
  handleResetPassword: (user) => safeCall(onResetPassword, user, "email"),
});
